import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=3291d25c&"
import script from "./SectionLoader.vue?vue&type=script&lang=js&"
export * from "./SectionLoader.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports